import { registerSW } from 'virtual:pwa-register';
import { isAppMode } from './config/mockAuth';

// Version detection lives in the browser + Workbox service worker update flow.
// This hook controls what the app does once the generated worker activates.
//
// The Electron app build (VITE_APP=true) opts OUT of the service worker: it serves
// the frontend from a local proxy and always needs the remote backend, so the
// precache buys no offline benefit — and a cached bundle that hard-redirects at
// startup (the CERN SSO login) can get stuck before autoUpdate swaps it in,
// permanently serving stale code that only a manual cache wipe recovers. So in the
// app build we skip registration AND unregister any worker a previous build left
// behind, clearing its caches so existing installs self-heal.
const unregisterServiceWorkers = async () => {
  if (!('serviceWorker' in navigator)) {
    return;
  }
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map(registration => registration.unregister()));
    if (window.caches) {
      const keys = await window.caches.keys();
      await Promise.all(keys.map(key => window.caches.delete(key)));
    }
  } catch {
    // Best-effort cleanup; never block app startup on it.
  }
};

export const registerAppServiceWorker = ({ reloadPage = () => window.location.reload() } = {}) => {
  if (isAppMode()) {
    unregisterServiceWorkers();
    return undefined;
  }
  return registerSW({
    immediate: true,
    onNeedReload: reloadPage,
  });
};
